import { jwtConfig } from "../../config";
//import jwtDecode from 'jwt-decode';

class JwtAuth {
  login = async (userInfo) => {
    console.log("User Ifoooo " + userInfo.username);
    if (!userInfo.username || !userInfo.password) {
      return { error: "Please fill in the username or password" };
    }
    if (userInfo.username === "" || userInfo.password === "") {
      return { error: "Please fill in the username or password" };
    }
    console.log("jwtConfig", jwtConfig.fetchUrl);
    return await fetch(jwtConfig.fetchUrl, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userInfo),
    })
      .then((response) => response.json())
      .then((res) => {
        //const result = {};
        console.log("res", res);
        return res;
      })
      .catch((error) => ({ error }));
  };
}
export default new JwtAuth();
